/**
 * CSV Export Utility
 * AI活用スコアデータをCSV形式でエクスポートするユーティリティ
 */

import { csvCell } from './csvCell';

export interface UsageScoreUser {
  id: number;
  name: string;
  email: string;
  used_agents: Array<{
    agent_id: number;
    name: string;
    count: number;
    usage_rate: number;
  }>;
}

/**
 * AI活用スコアデータをCSV形式でエクスポート
 *
 * @param users ユーザーデータ配列
 * @param startDate 開始日 (YYYY-MM-DD)
 * @param endDate 終了日 (YYYY-MM-DD)
 */
export const exportUsageScoreToCSV = (
  users: UsageScoreUser[],
  startDate: string,
  endDate: string
): void => {
  // CSVヘッダー行
  const headers = ['ユーザー名', 'メールアドレス', 'AIエージェント名', '実行回数', '使用率(%)'];

  // データ行を生成（全エージェントを含む）
  const rows = users.flatMap(user =>
    user.used_agents.map(agent => [
      csvCell(user.name),
      csvCell(user.email),
      csvCell(agent.name),
      agent.count.toString(),
      agent.usage_rate.toString()
    ])
  );

  // CSVコンテンツを生成
  const csvContent = [headers, ...rows]
    .map(row => row.join(','))
    .join('\n');

  // UTF-8 BOMを追加（Excel対応）
  const bom = '\uFEFF';
  const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });

  // ファイル名を生成
  const filename = `ai_usage_score_${startDate}_${endDate}.csv`;

  // ダウンロードを実行
  downloadBlob(blob, filename);
};

/**
 * Blobをファイルとしてダウンロード
 *
 * @param blob ダウンロードするBlob
 * @param filename ファイル名
 */
const downloadBlob = (blob: Blob, filename: string): void => {
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = filename;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();

  // クリーンアップ
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
